/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import KImage from '@/types/KImage'
import BottomSummaryPPLink from './BottomSummaryPPLink'

class BottomSummaryPP {
  private json: any
  public readonly uid: string;
  public readonly title: string;
  public readonly description: string;
  public readonly buttonLabel: string;
  public readonly buttonLink: BottomSummaryPPLink;
  public readonly icon?: KImage;

  constructor (json: any) {
    this.json = json
    this.uid = json.uid
    this.title = json.title
    this.description = json.description
    this.buttonLabel = json.button_label
    this.buttonLink = BottomSummaryPPLink.of(json.button_link)
    this.icon = json.section_icon
      ? new KImage(
        json.section_icon.url,
        json.section_icon.content_type,
        json.section_icon.filename
      )
      : undefined
  }

  static of (json: any): BottomSummaryPP {
    return new BottomSummaryPP(json)
  }
}

export default BottomSummaryPP
